import { QtmTypography } from '@qtm/react';
import clsx from 'clsx';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import useTailwindBreakpoints from 'hooks/useTailwindBreakpoints';
import isNumber from 'lodash/isNumber';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { Navigate, useNavigate } from 'react-router-dom';
import BottomButtonToolBar from 'shared/compoments/Buttons/BottomButtonToolBar';
import { defaultRatio, setRatio } from 'shared/reducers/selectionSlice';
import './ratio.css';

const availableRatios = [0, 25, 50, 75, 100];

const marks = availableRatios.reduce((acc, value) => {
  acc[value] = `${value}%`;
  return acc;
}, {} as any);

const ChooseSatRatio = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { isSm } = useTailwindBreakpoints();
  const areaId = useAppSelector(({ selection }) => selection.areaId);
  const revisitTime = useAppSelector(({ selection }) => selection.revisitTime);
  const ratio = useAppSelector(({ selection }) => selection.ratio);

  if (!isNumber(areaId) || !isNumber(revisitTime)) {
    return <Navigate to="/sat/area/type" />;
  }

  const onBack = async () => {
    if (!isNumber(ratio)) {
      await dispatch(setRatio(defaultRatio));
    }
    navigate('/sat/revisit/2');
  };

  const onNext = async () => {
    if (!isNumber(ratio)) {
      await dispatch(setRatio(defaultRatio));
    }
    navigate('/sat/constellations/4');
  };

  const onChange = (value: number | number[]) => {
    if (!Array.isArray(value)) {
      dispatch(setRatio(value));
    }
  };

  const ratioValue = isNumber(ratio) ? ratio : defaultRatio;

  const titleSize = isSm ? 'title-3' : 'title-2';
  const subTitleSize = isSm ? 'text-scale-5' : 'text-scale-4';

  return (
    <>
      <QtmTypography component={titleSize} classes="text-white-100">
        <span className="hidden md:inline">Set your Satellite Ratio</span>
        <span className="xs:inline md:hidden">Radar Satellites</span>
      </QtmTypography>
      <QtmTypography classes={`${subTitleSize} text-white-100 font-helvetica`}>
        You will set the radar satellites ratio in your constellation.
        <br />
        It's a key driver for you Revisit Time: The more radar
        <br />
        satellites you have, the better revisit time you will have.
      </QtmTypography>
      <div className="w-full px-l">
        <div
          className={clsx('ratio-slider', { isSm })}
          style={{
            paddingTop: '75px',
          }}
        >
          <Slider
            marks={marks}
            min={availableRatios[0]}
            max={availableRatios[availableRatios.length - 1]}
            step={null}
            value={ratioValue}
            onChange={onChange}
            styles={{
              track: {
                backgroundColor: 'var(--slider-primary-handle-background-color)',
                height: '10px',
              },
              rail: {
                backgroundColor: 'var(--color-bluegrey-850)!important',
                height: '10px',
              },
              handle: {
                borderColor: 'var(--slider-primary-handle-background-color)',
                backgroundColor: 'var(--slider-primary-handle-background-color)',
                height: 28,
                width: 28,
                marginTop: -9,
              },
            }}
          />
          <div className="ratio-indicators">
            <QtmTypography classes="text-primary-300">{ratioValue}% Radar</QtmTypography>
            <QtmTypography classes="text-primary-300">{100 - ratioValue}% Optical</QtmTypography>
          </div>
        </div>
      </div>
      <BottomButtonToolBar onBack={onBack} onNext={onNext} />
    </>
  );
};

export default ChooseSatRatio;
